import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, Label, Input, Col, Row, Button } from 'reactstrap';

import Select from 'react-select'
import MultiSelectField from '../businesses/MultiSelectField';

const InputFieldRenderer = ({
  label, name, inputField, type, placeholder, handleChange, handleBlur, required, ...restProps
}) => {
  const { value, error } = inputField;

  return (
    <Fragment>
      <Label for={name}>{label}</Label>
      <Input
        {...restProps}
        type={type}
        name={name}
        id={name}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={handleBlur}
        required={required}
      />
      {required && (<div className="row error">{error}</div>)}
    </Fragment>
  );
}

class SurveyTemplateForm extends React.Component {
  render() {
    const {
      surveyCategories,
      surveyCategory,
      surveyName,
      surveyDescription,
      handleBlur,
      handleChange,
      handleSubmit,
      handleSelectChange,
      businessLabels,
      handleCancel,
      editForm
    } = this.props;

    const submitTitle = editForm ? 'Save Changes' : 'Create Survey Template';

    return (
      <Form noValidate>
        <h3 className="mb-4">{editForm ? "Edit" : "Create a"} Survey Template</h3>
        <Row>
          <Col md={9}>
            <FormGroup>
              <InputFieldRenderer
                label="Survey Name"
                placeholder="Survey Name"
                type="text"
                name="surveyName"
                inputField={surveyName}
                handleChange={handleChange}
                handleBlur={handleBlur}
                required
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label for="surveyCategory">Survey Category</Label>
              <Select
                simpleValue
                isClearable={false}
                onChange={(value) => { handleSelectChange(value, 'surveyCategory') }}
                options={surveyCategories}
                value={surveyCategory.value}
              />
              <div className="row error">{surveyCategory.error}</div>
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <InputFieldRenderer
            label="Survey Description"
            placeholder="Survey Description"
            type="textarea"
            name="surveyDescription"
            inputField={surveyDescription}
            handleChange={handleChange}
            handleBlur={handleBlur}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="businessLabels">Business Category Labels</Label>
          <MultiSelectField
            value={businessLabels.value}
            handleSelectChange={(value) => { handleSelectChange(value, 'businessLabels') }}
          />
          <div className="row error">{businessLabels.error}</div>
        </FormGroup>
        <FormGroup className="d-flex justify-content-end">
          <Button className="mr-2" onClick={handleSubmit}>{submitTitle}</Button>
          <Button className="border-dark" onClick={handleCancel} color={"white"}>Cancel</Button>
        </FormGroup>
      </Form>
    );
  }
}

SurveyTemplateForm.propTypes = {
  surveyCategories: PropTypes.array,
  surveyCategory: PropTypes.object,
  surveyName: PropTypes.string,
  surveyDescription: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleSelectChange: PropTypes.func,
  businessLabels: PropTypes.array,
  handleCancel: PropTypes.func,
  editForm: PropTypes.bool
};

export default SurveyTemplateForm;



// WEBPACK FOOTER //
// ./src/components/categories/SurveyTemplateForm.js